module.exports = __webpack_public_path__ + "img/step_02.e3e2d07b.png";